import alasql from "alasql";
import universeHelper from "../components/pages/Create/universe/universeHelper";

var initialState = {
  steps: {
    risk: {
      title: "Select Risk Profile",
      full_title: "Select risk portfolio",
      active: {},
      activePortfolioID: 0,
      scenarioName: "",
      displayPopUp: true,
      benchmark_name: "",
      orig_scenario_id: 0,
      templateData: {},
      display_orig_portfolio: false,
      direct_review_portfolio: false,
    },
    universe: {
      title: "Select account universe",
      full_title: "Select account universe",
      symbols: [],
      cloneTableInitialData: [],
      securitiesValidToNextStep: true,
      cloneStyles: [],
      cloneSymbols: [],
      cloneAssetClass: [],
      cloneFundType: [],
      deleteSecuritiesList: [],
    },
    universeLite: {
      portfolio: [],
      historical_returns: [],
      historical_returns_error: false,
      model_id: "",
      model_name: null,
      portfolioActive: false,
      lite_symbols: [],
      allocationSumError: false,
      benchmark: "",
      securityUniverseActive: false,
      analyzeExistingActive: false,
      active_optimize_using_myUniverse: false,
      compare_portfolio_id_analyze: 0,
      analyze_merged_portfolio: [],
      delete_lite_portfolios: [],
      excluded_securities: [],
      predefined_models: {
        iqcio_model_list: [],
        my_portfolio_list: [],
        selected_predefined_model: "iqcioModel",
      },
      analyze_compare: {
        yourTable: [],
        yourChartOptions: [],
        yourDrilldown: [],
        iqcioChartOptions: [],
        iqcioDrilldown: [],
        iqcioTable: [],
        clientBacktestData: {},
        riskStatistics: [],
        getPerfHistmetrics: [],
      },
    },
    tuners_absolute_selection: {
      selected_type: "",
      absolute_max_vol: false,
      absolute_min_return: false,
      absolute_max_beta: false,
    },
    fundType: {
      displayStyleError: false,
    },
    parameters: {
      uniqueTableData: [],
      selectedItems: [],
      pickedParameter: [],
    },
    bechmark: {
      title: "Benchmark selection",
      full_title: "Benchmark selection",
    },
    limits: {
      title: "Configure limits",
      full_title: "Configure limits",
      scenario_limits: [],
      formData: {},
      active: [
        {
          asset_class: [],
          fund_type: [],
        },
      ],
    },
    backendParams: {
      optimization_params: {},
      fund_type: [],
      asset_class: [],
      overall_focus: [],
      styles: [],
    },
    stepsCount: 0,
    resetDataAlert: false,
    uri: "",
    create_review_model: {
      direct_review_portfolio: false,
      compare_portfolio_id: 0,
    },
  },
  modelportfolios: [],
  concatedScenarioShortlist: {},
  create_portfolio_type: "",
  asset_class_array: [],
  manualsecurity: [],
  SecurityAddedManually: [],
  addPannel: true,
};

export default function create(
  state = JSON.parse(JSON.stringify(initialState)),
  action
) {
  const { payload, type } = action;

  let newState = Object.assign({}, state);

  switch (action.type) {
    case "SET_PORTFOLIOS":
      newState.modelportfolios = payload;
      var _obj = {};
      var data = newState.modelportfolios;
      for (let i = 0; i < data.length; i++) {
        var tempObj = {};
        tempObj["max_vol"] =
          data[i]["data"][0]["optimization_params"]["max_vol"] * 1;
        tempObj["min_return"] =
          data[i]["data"][0]["optimization_params"]["min_return"] * 1;
        tempObj["upper_bounds"] =
          data[i]["data"][0]["optimization_params"]["upper_bounds"] * 1;
        tempObj["benchmark"] =
          data[i]["data"][0]["optimization_params"]["benchmark"];

        // beta
        tempObj["max_beta"] =
          data[i]["data"][0]["optimization_params"]["max_beta"] * 1;

        _obj[data[i]["data"][0]["scenario_id"]] = tempObj;
      }
      newState.steps.backendParams.optimization_params = _obj;

      break;
    case "SET_TABLE_CONCATED_SCENARIOSHORTLIST":
      newState.concatedScenarioShortlist = payload;
      break;

    case "RESET_PORTFOLIO_CREATE":
      newState.modelportfolios = [];
      newState.concatedScenarioShortlist = {};
      break;

    case "SET_ACTIVE_GOAL":
      newState.steps.risk.active = action.payload;
      newState.steps.risk.activePortfolioID = 0;

      break;

    case "SET_PORTFOLIO_ID":
      const activePotfolio = alasql(
        `SELECT * FROM ? WHERE scenario_id = '${action.payload}' LIMIT 1`,
        [newState.steps.risk.active.data]
      );
      newState.steps.backendParams.fund_type = activePotfolio[0].fund_type;
      // newState.steps.backendParams.asset_class = activePotfolio[0].asset_class;
      // newState.steps.backendParams.overall_focus = activePotfolio[0].overall_focus;
      // newState.steps.backendParams.styles = activePotfolio[0].styles;

      newState.steps.backendParams.asset_class =
        activePotfolio[0].asset_class.filter((d) => d.name !== "Cash");
      newState.steps.backendParams.overall_focus =
        activePotfolio[0].overall_focus;
      // .filter(
      //   (d) => d.name !== "Cash"
      // );
      newState.steps.backendParams.styles = activePotfolio[0].styles.filter(
        (d) => d.style !== "Cash"
      );

      //   newState.steps.backendParams.optimization_params = {
      //     max_vol:
      //       +activePotfolio[0].optimization_params.max_vol > 100
      //         ? 0
      //         : +activePotfolio[0].optimization_params.max_vol,
      //     min_return:
      //       +activePotfolio[0].optimization_params.min_return < 0
      //         ? 0
      //         : +activePotfolio[0].optimization_params.min_return,
      //     upper_bounds: +activePotfolio[0].optimization_params.upper_bounds
      //   };
      newState.steps.risk.activePortfolioID = action.payload;

      break;

    case "SET_DIRECT_REVIEW_PORTFOLIO_MODELPORTFOLIO":
      newState.steps.backendParams.fund_type = payload.fund_type;
      newState.steps.backendParams.asset_class = payload.asset_class.filter(
        (d) => d.name.toUpperCase() !== "Cash"
      );
      newState.steps.backendParams.overall_focus = payload.overall_focus.filter(
        (d) => d.name !== "Cash"
      );
      newState.steps.backendParams.styles = payload.styles.filter(
        (d) => d.style !== "Cash"
      );

      newState.steps.risk.activePortfolioID = payload.activePortfolioID;
      newState.steps.risk.benchmark_name = payload.benchmark_name;
      newState.steps.backendParams.optimization_params = {
        ...payload.optimization_params,
      };

      if (payload.absolute_flag && payload.absolute_flag * 1 > 0) {
        if (payload.absolute_flag * 1 === 1) {
          newState.steps.tuners_absolute_selection.absolute_max_vol = true;
        } else if (payload.absolute_flag * 1 === 2) {
          newState.steps.tuners_absolute_selection.absolute_min_return = true;
        } else if (payload.absolute_flag * 1 === 3) {
          newState.steps.tuners_absolute_selection.absolute_max_beta = true;
        }
      } else {
        newState.steps.tuners_absolute_selection.absolute_max_vol = false;
        newState.steps.tuners_absolute_selection.absolute_min_return = false;
        newState.steps.tuners_absolute_selection.absolute_max_beta = false;
      }
      break;
    case "SET_BENCHMARK_LITE":
      newState.steps.universeLite.benchmark = action.payload;
      break;
    case "SET_UNIVERSE_DATA":
      newState.steps.universe.symbols = action.payload;
      break;

    case "SET_INITIAL_TABLE_DATA":
      newState.steps.universe.cloneTableInitialData = action.payload;
      break;

    case "LIST_OF_SECURITIES_TO_DELETE":
      let secutites_selected = [
        ...newState.steps.universe.deleteSecuritiesList,
      ];
      secutites_selected.push(action.payload);
      newState.steps.universe.deleteSecuritiesList = [...secutites_selected];
      break;
    case "UNDO_LIST_OF_SECURITIES_TO_DELETE":
      let _secutites_selected = [
        ...newState.steps.universe.deleteSecuritiesList,
      ];
      let filtered_securities = _secutites_selected.filter(
        (symbol) => action.payload !== symbol
      );

      newState.steps.universe.deleteSecuritiesList = [...filtered_securities];
      break;
    case "SET_SCENARIO_LIMITS":
      newState.steps.limits.scenario_limits = action.payload;

      break;

    case "SET_SYMBOL_VALUE":
      newState.steps.universe.symbols[action.payload.i][action.payload.key] =
        action.payload.value;

      break;

    case "SET_SYMBOLS_VALUE_NEW":
      newState.steps.universe.symbols.forEach(function (part, index, theArray) {
        if (theArray[index]["symbol"] === payload.symbol) {
          theArray[index]["val"] = payload.value;
        }
      });
      break;
    case "SET_SYMBOLS_VALUE_LITE_NEW":
      newState.steps.universeLite.portfolio.forEach(function (
        part,
        index,
        theArray
      ) {
        if (theArray[index]["symbol"] === payload.symbol) {
          theArray[index]["val"] = payload.value;
        }
      });
      break;
    case "SET_PORTFOLIO_NAME":
      newState.steps.risk.scenarioName = action.payload;

      break;

    case "SET_BENCHMARKNAME":
      newState.steps.risk.benchmark_name = action.payload;
      break;

    case "ADD_UNIVERSE_DATA":
      let addSymbols = [...newState.steps.universe.symbols];

      let obj = action.payload;
      function addSymbol(addSymbol, obj) {
        let fundName = obj["fund_name"];
        let found = addSymbols.some((el) => el["fund_name"] === fundName);

        if (found) {
          addSymbols.map((Ob) =>
            Ob["fund_name"] == fundName ? (Ob["val"] = obj["val"]) : Ob
          );
        } else {
          addSymbol.push(obj);
        }
      }
      addSymbol(addSymbols, obj);
      // addSymbols.push(action.payload);
      newState.steps.universe.symbols = [...addSymbols];

      break;

    case "REMOVE_UNIVERSE_DATA":
      let removeSymbols = newState.steps.universe.symbols;

      let universe_selected_symbols = payload;
      let symbols_removed_universe_data = removeSymbols.filter(
        (ob) => !universe_selected_symbols.includes(ob["symbol"])
      );

      newState.steps.universe.symbols = [...symbols_removed_universe_data];

      // checks if valid to proceed to next step
      let activePortfolio = newState.steps.risk.activePortfolioID;
      let optimizedParam = newState.steps.backendParams.optimization_params;
      let upperBound = optimizedParam[activePortfolio].upper_bounds;

      newState.steps.universe.securitiesValidToNextStep =
        universeHelper.securityValidate(
          upperBound,
          symbols_removed_universe_data.length
        );
      break;

    case "CHANGE_PORTFOLIO":
      newState.steps.limits.active =
        newState.modelportfolios[action.payload].data;

      break;

    case "CHANGE_PERCENT":
      const { ixs = [], value } = payload;

      let { json } = newState;

      ixs.forEach((ix, i) => {
        if (ixs[i + 1]) json = json[ix].individual_weights;
        else if (!ixs[i + 1])
          ixs.length != 4
            ? (json[ix].total_weight = +value)
            : (json[ix] = +value);
      });

      newState.json = {
        ...newState.json,
      };

      break;

    case "CHANGE_UI_PARAMS":
      const { ui_ixs = [], ui_value, id } = payload;

      const key = payload.ui_ixs[1];
      // const objectValue = { ui_ixs[1]: ui_value };
      var obj = {};
      obj[key] = ui_value;
      const { backendParams } = { ...newState.steps };
      let backend = { ...backendParams.optimization_params[id] };
      backend = { ...backend, ...obj };
      // newState.steps.backendParams;
      // ui_ixs.forEach((ix, i) => {
      // backendParams = uiwState.steps.backendParams.optimization_params = {
      //     max_vol:
      //       +activePotfolio[0].optimization_params.max_vol > 100
      //         ? 0
      //         : +activePotfolio[0].optimization_params.max_vol,
      //     min_return:
      //       +activePotfolio[0].optimization_params.min_return < 0
      //         ? 0
      //         : +activePotfolio[0].optimization_params.min_return,
      //     upper_bounds: +activePotfolio[0].optimization_params.upper_bounds
      //   };_ixs[i + 1] ? backendParams[ix] : backendParams;
      // });

      backendParams["optimization_params"][id] = backend;

      newState.steps.backendParams = {
        ...newState.steps.backendParams,
      };

      break;

    case "CHANGE_FUND_TYPE":
      newState.steps.backendParams.fund_type[payload.i].min =
        payload.min.toString();
      newState.steps.backendParams.fund_type[payload.i].max =
        payload.max.toString();

      newState.steps.backendParams = {
        ...newState.steps.backendParams,
      };

      break;

    case "CHANGE_ASSET_CLASS":
      newState.steps.backendParams.asset_class[payload.i].min =
        payload.min.toString();
      newState.steps.backendParams.asset_class[payload.i].max =
        payload.max.toString();

      newState.steps.backendParams = {
        ...newState.steps.backendParams,
      };

      break;

    case "CHANGE_OVERALL_FOCUS":
      newState.steps.backendParams.overall_focus[payload.i].min =
        payload.min.toString();
      newState.steps.backendParams.overall_focus[payload.i].max =
        payload.max.toString();

      newState.steps.backendParams = {
        ...newState.steps.backendParams,
      };

      break;
    case "CHANGE_STYLE":
      newState.steps.backendParams.styles[payload.i].min =
        payload.min.toString();
      newState.steps.backendParams.styles[payload.i].max =
        payload.max.toString();

      newState.steps.backendParams = {
        ...newState.steps.backendParams,
      };
      break;

    case "SET_CREATEPORTFOLIO_COMMON_LIMIT_SLIDER":
      console.log(action.payload);
      let slider_group_data = newState.steps.backendParams[payload.group];

      let slider_group_new_data;

      if (
        payload.group.toLowerCase() === "styles" ||
        payload.group.toLowerCase() === "style"
      ) {
        let list = [
          {
            style: payload.name,
            min: (payload.min / 100).toString(),
            max: (payload.max / 100).toString(),
          },
        ];
        slider_group_new_data = slider_group_data.map(
          (obj) => list.find((o) => o.style === obj.style) || obj
        );
      } else {
        let list = [
          {
            name: payload.name,
            min: (payload.min / 100).toString(),
            max: (payload.max / 100).toString(),
          },
        ];
        slider_group_new_data = slider_group_data.map(
          (obj) => list.find((o) => o.name === obj.name) || obj
        );
      }

      newState.steps.backendParams[payload.group] = slider_group_new_data;
      break;

    case "SET_UI_PARAMS":
      newState.ui_params = payload;
      newState.steps.limits.scenario_limits = payload;

      break;

    case "RESET_PORTFOLIOS":
      newState = JSON.parse(JSON.stringify(initialState));

      break;
    case "RESET_MANUALLY_ADDED_SECURITIES":
      newState.SecurityAddedManually = [];
      break;

    case "DISPLAY_POPUP_FORM":
      newState.steps.risk.displayPopUp = action.payload;
      break;

    // clone initial data of universe sliders
    case "SET_UNIVERSE_CLONE_STYLES":
      newState.steps.universe.cloneStyles = [...action.payload];
      break;

    // parameters page
    case "PARAM_TABLEDATA":
      newState.steps.parameters.uniqueTableData = action.payload;
      break;

    case "PARAM_SELECTEDLIST":
      newState.steps.parameters.selectedItems = action.payload;
      break;

    case "PARAM_FINALSELECTEDList":
      newState.steps.parameters.pickedParameter = action.payload;
      break;

    // universe step 2 validation to nest step
    case "SET_UNIVERSE_SECURITYVALIDITY":
      newState.steps.universe.securitiesValidToNextStep = action.payload;
      break;

    // create portfolio step 3 reset slider value to zero
    case "SET_BACKENDPARAMS_STYLE_RESET":
      newState.steps.backendParams.styles = [...action.payload];
      break;
    case "SET_BACKENDPARAMS_CLASS_RESET":
      newState.steps.backendParams.asset_class = [...action.payload];
      break;
    case "SET_BACKTESTPARAMS_OVERALL_FOCUS":
      newState.steps.backendParams.overall_focus = [...action.payload];
      break;
    // universe lite
    case "SET_UNIVERSE_LITE_SYMBOLS":
      newState.steps.universeLite.lite_symbols = action.payload;
      break;
    case "SET_UNIVERSE_LITE_PORTFOLIO":
      newState.steps.universeLite.portfolio = action.payload;
      break;

    case "SET_UNIVERSE_LITE_ACTIVE":
      newState.steps.universeLite.portfolioActive = action.payload;
      break;

    case "SET_UNIVERSE_LITE_SYMBOL_VALUE":
      newState.steps.universeLite.portfolio[action.payload.i][
        action.payload.key
      ] = action.payload.value * 1;
      // if value is zero then set action to sell
      // if(action.payload.value == 0){
      //   alert("value is 0");
      //   newState.steps.universeLite.portfolio[action.payload.i]["action"] = "sell";
      // }
      if (action.payload.key == "date") {
        newState.steps.universeLite.portfolio[action.payload.i][
          action.payload.key
        ] = action.payload.value;
      }
      break;
    case "SET_UNIVERSE_LITE_ACTION":
      if (action.payload.value == "delete") {
        let x = newState.steps.universeLite.portfolio;
        let remove = x.splice(action.payload.i, 1);

        newState.steps.universeLite.portfolio = [...x];
      } else {
        newState.steps.universeLite.portfolio[action.payload.i][
          action.payload.key
        ] = action.payload.value;
      }
      break;
    case "DELETE_UNIVERSE_LITE_DATA":
      let removePortfolio = newState.steps.universeLite.portfolio;

      let universe_selected_list = payload;
      let universe_removed_symbols_data = removePortfolio.filter(
        (el) => !universe_selected_list.includes(el["symbol"])
      );
      newState.steps.universeLite.portfolio = [
        ...universe_removed_symbols_data,
      ];
      break;
    // old add button
    case "ADD_UNIVERSE_LITE_DATA":
      let litedata = newState.steps.universeLite.portfolio;

      litedata.unshift({
        fund_type: "",
        symbol: "",
        new_classification: "",
        fund_asset_class_focus: "",
        new_style: "",
        val: "",
        action: "keep",
      });

      newState.steps.universeLite.portfolio = [...litedata];

      break;

    // new add button
    case "ADD_UNIVERSE_LIST_ELEMENT":
      let litedataElement = newState.steps.universeLite.portfolio;
      let listElement = action.payload;

      litedataElement.push(listElement);

      newState.steps.universeLite.portfolio = [...litedataElement];
      break;

    //ADD MANUAL SECURITY
    //SS
    case "ADD_MANUAL_SECURITY_TO_UNIVERSE":
      let universe = newState.steps.universe;
      let backendUpdate = newState.steps.backendParams;
      let styleExist = universe.cloneStyles.includes(payload["new_style"]);
      if (!styleExist) {
        universe.cloneStyles.push({
          style: payload["new_style"],
          min: "0",
          max: "1",
        });
      }
      let newPayload = {
        ...payload,
      };
      universe.cloneTableInitialData = [
        ...universe.cloneTableInitialData,
        newPayload,
      ];
      let SymbolFound = universe.symbols.some(
        (e) =>
          JSON.stringify(e["fund_name"]) ===
          JSON.stringify(newPayload["fund_name"])
      );
      if (!SymbolFound) universe.symbols = [...universe.symbols, newPayload];
      if (SymbolFound) {
        console.log("hmm");
        universe.symbols.map((Ob) =>
          Ob["fund_name"] == payload["fund_name"]
            ? (Ob["val"] = payload["val"])
            : Ob
        );
      }
      if (
        !backendUpdate.asset_class.some(
          (e) => e.name === payload["new_classification"]
        )
      ) {
        console.log("Inside asset/gives classification");
        let insertObj = {
          max: (
            backendUpdate.optimization_params[
              state.steps.risk.activePortfolioID
            ]["upper_bounds"] / 100
          ).toString(),
          min: "0",
          name: payload["new_classification"],
        };
        backendUpdate.asset_class = [...backendUpdate.asset_class, insertObj];
      }
      if (
        !backendUpdate.overall_focus.some(
          (e) => e.name === payload["fund_asset_class_focus"]
        )
      ) {
        console.log("Inside overall/gives asset");
        let insertObj = {
          max: "1",
          min: "0",
          name: payload["fund_asset_class_focus"],
        };
        backendUpdate.overall_focus = [
          ...backendUpdate.overall_focus,
          insertObj,
        ];
      }

      newState.SecurityAddedManually.push(payload);
      break;

    case "ADD_MANUAL_SECURITY_TO_MYUNIVERSE":
      let myuniverse = newState.steps.universeLite.portfolio;
      let InsertObjectToMyUniverse = {
        action: "keep",
        addedRow: true,
        fund_asset_class_focus: payload.fund_asset_class_focus,
        fund_name: payload.fund_name,
        initial_allocation: null,
        new_classification: payload.new_classification,
        new_fund_type: "STOCK",
        new_style: payload.new_style,
        symbol: payload.symbol,
        val: payload.val,
      };
      let found = myuniverse.some(
        (e) =>
          JSON.stringify(e["fund_name"]) ===
          JSON.stringify(payload["fund_name"])
      );
      if (found) {
        myuniverse.map((Ob) =>
          Ob["fund_name"] == payload["fund_name"]
            ? (Ob["val"] = InsertObjectToMyUniverse["val"])
            : Ob
        );
      } else {
        myuniverse.push(InsertObjectToMyUniverse);
      }
      break;

    case "ALLOCATION_SUM_ERROR":
      newState.steps.universeLite.allocationSumError = action.payload;
      break;
    // fund type error handlers
    case "SET_FUNDTYPE_ERROR":
      newState.steps.fundType.displayStyleError = action.payload;
      break;

    // set orig scn_ id
    case "SET_ORIG_SCENARIO_ID":
      newState.steps.risk.orig_scenario_id = action.payload;
      break;
    // risk page template table data
    case "SET_RISKTABLE_TEMPLATES":
      newState.steps.risk.templateData = action.payload;
      break;

    //set current step count
    case "SET_ACTIVE_STEP_COUNT":
      newState.steps.stepsCount = action.payload;
      break;

    case "SET_CREATE_PORTFOLIO_DATA_RESET_ALERT":
      newState.steps.resetDataAlert = action.payload;
      break;
    case "SET_CREATE_PORTFOLIO_ASSOCIATED_ROUTE":
      newState.steps.uri = action.payload;
      break;
    case "SET_SECURITY_UNIVERSE_LITE":
      newState.steps.universeLite.securityUniverseActive = action.payload;
      break;

    case "SET_ANALYZE_UNIVERSE_LITE":
      newState.steps.universeLite.analyzeExistingActive = action.payload;
      break;

    case "SET_BACKENDPARAMS_SECURITY_UNIVERSE_LIMITS_DATA":
      let { fund_type, asset_class, overall_focus, styles } = action.payload;
      newState.steps.backendParams.fund_type = fund_type;

      newState.steps.backendParams.asset_class = asset_class.filter(
        (d) => d.name !== "Cash"
      );
      newState.steps.backendParams.overall_focus = overall_focus.filter(
        (d) => d.name !== "Cash"
      );
      newState.steps.backendParams.styles = styles.filter(
        (d) => d.style !== "Cash"
      );
      break;

    case "SET_UNIVERSE_LITE_HISTORICAL_RETURNS":
      newState.steps.universeLite.historical_returns = [...action.payload];
      break;
    case "SET_UNIVERSE_LITE_HISTORICAL_RETURNS_VALUE":
      newState.steps.universeLite.historical_returns[action.payload.index][
        action.payload.key
      ] = action.payload.value;
      break;
    case "SET_UNIVERSE_LITE_HISTORICAL_RETURNS_ERROR":
      newState.steps.universeLite.historical_returns_error = action.payload;
      break;
    case "SET_UNIVERSE_LITE_MODEL_ID":
      newState.steps.universeLite.model_id = action.payload;
      break;
    case "SET_UNIVERSE_LITE_MODEL_NAME":
      newState.steps.universeLite.model_name = action.payload;
      break;
    case "SET_ACTIVE_OPTIMIZE_USING_MYUNIVERSE":
      newState.steps.universeLite.active_optimize_using_myUniverse = payload;
      break;

    case "SET_COMPARE_PORTFOLIO_ID_ANALYZE":
      newState.steps.universeLite.compare_portfolio_id_analyze = payload * 1;
      break;

    case "SET_ANALYZE_MERGED_PORTFOLIOS":
      newState.steps.universeLite.analyze_merged_portfolio = payload;
      break;

    case "DELETE_ANALYZE_MERGED_PORTFOLIOS":
      let clc_delete_lite_portfolios = [
        ...newState.steps.universeLite.delete_lite_portfolios,
      ];

      clc_delete_lite_portfolios.push(action.payload);

      newState.steps.universeLite.delete_lite_portfolios = [
        ...clc_delete_lite_portfolios,
      ];

      break;
    case "UNDO_DELETE_ANALYZE_MERGED_PORTFOLIOS":
      let undo_delete_lite_portfolios = [
        ...newState.steps.universeLite.delete_lite_portfolios,
      ];

      undo_delete_lite_portfolios = undo_delete_lite_portfolios.filter(
        (symbol) => symbol !== action.payload
      );

      newState.steps.universeLite.delete_lite_portfolios = [
        ...undo_delete_lite_portfolios,
      ];

      break;
    case "ADD_ANALYZE_MERGED_PORTFOLIOS":
      let addSym = [...newState.steps.universeLite.analyze_merged_portfolio];

      // let obj_merge = action.payload;
      let list = action.payload;

      function addSymbol({ addSym, obj_merge }) {
        let fundName = obj_merge["fund_name"];
        let found = addSym.some((el) => el["fund_name"] === fundName);

        if (found) {
          addSym.map((Ob) =>
            Ob["fund_name"] == fundName ? (Ob["val"] = obj_merge["val"]) : Ob
          );
        } else {
          addSym.push(obj_merge);
        }
      }
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          addSymbol({ addSym, obj_merge: list[i] });
        }
      }
      newState.steps.universeLite.analyze_merged_portfolio = [...addSym];

      break;

    case "SET_ANALYZE_MERGED_ALLOCATION_VALUE":
      newState.steps.universeLite.analyze_merged_portfolio[action.payload.i][
        action.payload.key
      ] = action.payload.value * 1;
      break;

    case "SET_ANALYZE_MERGED_ALLOCATION_VALUE_NEW":
      newState.steps.universeLite.analyze_merged_portfolio.forEach(function (
        part,
        index,
        theArray
      ) {
        if (theArray[index]["symbol"] === payload.symbol) {
          theArray[index]["core_allocation"] = payload.value;
        }
      });
      break;

    case "SET_ANALYZE_ANALYSIS_COMPARE_YOUR_PORTFOLIOS":
      newState.steps.universeLite.analyze_compare.yourChartOptions =
        payload.yourChartOptions;
      newState.steps.universeLite.analyze_compare.yourDrilldown =
        payload.yourDrilldown;
      newState.steps.universeLite.analyze_compare.yourTable = payload.yourTable;
      break;

    case "SET_ANALYZE_ANALYSIS_COMPARE_IQCIO_PORTFOLIOS":
      newState.steps.universeLite.analyze_compare.iqcioChartOptions =
        payload.iqcioChartOptions;
      newState.steps.universeLite.analyze_compare.iqcioDrilldown =
        payload.iqcioDrilldown;
      newState.steps.universeLite.analyze_compare.iqcioTable =
        payload.iqcioTable;
      break;

    case "SET_ANALYZE_ANALYSIS_CLIENT_BACKTEST_DATA":
      newState.steps.universeLite.analyze_compare.clientBacktestData = payload;
      break;

    case "SET_ANALYZE_ANALYSIS_RISK_STATISTICS":
      newState.steps.universeLite.analyze_compare.riskStatistics = payload;
      break;
    case "SET_ANALYZE_ANALYSIS_PERF_HISTMETRICS":
      newState.steps.universeLite.analyze_compare.getPerfHistmetrics = payload;
      break;

    case "SET_ORIG_PORTFOLIO_DISPLAY":
      newState.steps.risk.display_orig_portfolio = payload;
      break;
    case "RESET_CREATE_PORTFOLIO_ANALYZE":
      newState.steps.universeLite.analyzeExistingActive = false;
      newState.steps.universeLite.analyze_compare.clientBacktestData = {};
      newState.steps.universeLite.analyze_compare.iqcioChartOptions = [];
      newState.steps.universeLite.analyze_compare.iqcioDrilldown = [];
      newState.steps.universeLite.analyze_compare.iqcioTable = [];
      newState.steps.universeLite.analyze_compare.riskStatistics = [];
      newState.steps.universeLite.analyze_compare.yourChartOptions = [];
      newState.steps.universeLite.analyze_compare.yourDrilldown = [];
      newState.steps.universeLite.analyze_compare.yourTable = [];
      newState.steps.universeLite.analyze_compare.getPerfHistmetrics = [];
      newState.steps.universeLite.model_id = "";
      newState.steps.universeLite.model_name = null;
      newState.steps.universeLite.benchmark = "";
      newState.steps.display_orig_portfolio = false;
      newState.steps.risk.display_orig_portfolio = false;
      break;

    case "SET_DIRECT_REVIEW_PORTFOLIO":
      newState.steps.create_review_model.direct_review_portfolio = payload;
      break;
    // case "SET_DIRECT_REVIEW_PORTFOLIO_OPTIMIZE_DATA":
    //   // newState.steps.create_review_model.optimization_params.benchmark = payload.benchmark;
    //   newState.steps.create_review_model.optimization_params.max_beta =
    //     payload.max_beta;
    //   newState.steps.create_review_model.optimization_params.max_vol =
    //     payload.max_vol;
    //   newState.steps.create_review_model.optimization_params.min_return =
    //     payload.min_return;
    //   newState.steps.create_review_model.optimization_params.upper_bounds =
    //     payload.upper_bounds;
    //   break;
    case "SET_DIRECT_REVIEW_COMPARE_PORTFOLIO_ID":
      newState.steps.create_review_model.compare_portfolio_id = payload;
      break;
    case "RESET_DIRECT_REVIEW_PORTFOLIO_OPTIMIZE_DATA":
      newState.steps.create_review_model.direct_review_portfolio = false;

      newState.steps.backendParams.optimization_params = {};

      newState.steps.backendParams.fund_type = [];
      newState.steps.backendParams.asset_class = [];
      newState.steps.backendParams.overall_focus = [];
      newState.steps.backendParams.styles = [];
      newState.steps.create_review_model.compare_portfolio_id = 0;
      // newState.steps.create_review_model.optimization_params.max_beta = 0;
      // newState.steps.create_review_model.optimization_params.max_vol = 0;
      // newState.steps.create_review_model.optimization_params.min_return = 0;
      // newState.steps.create_review_model.optimization_params.upper_bounds = 0;
      // newState.steps.create_review_model.optimization_params.benchmark = "";

      break;

    case "SET_UNIVERSE_LITE_EXCLUDED_SECURITIES":
      newState.steps.universeLite.excluded_securities = payload;
      break;
    case "SET_UNIVERSE_LITE_PRE_DEFINED_MODEL_SELECTED":
      newState.steps.universeLite.predefined_models.selected_predefined_model =
        payload;
      break;

    case "SET_UNIVERSE_LITE_PRE_DEFINED_MODELS":
      newState.steps.universeLite.predefined_models.iqcio_model_list =
        payload.iqcio_model_list;
      newState.steps.universeLite.predefined_models.my_portfolio_list =
        payload.my_portfolio_list;
      break;
    case "RESET_SET_UNIVERSE_LITE_PRE_DEFINED_MODEL":
      newState.steps.universeLite.predefined_models.selected_predefined_model =
        "iqcioModel";
      newState.steps.universeLite.predefined_models.iqcio_model_list = [];
      newState.steps.universeLite.predefined_models.my_portfolio_list = [];
      newState.steps.universeLite.model_id = "";
      newState.steps.universeLite.model_name = null;

      // reset list of selected universe symbols to delete
      newState.steps.universe.deleteSecuritiesList = [];
      newState.steps.universeLite.delete_lite_portfolios = [];
      break;

    case "CREATE_STEP_ABSOLUTE_SWITCH_HANDLER":
      if (payload.name === "max_vol") {
        newState.steps.tuners_absolute_selection.absolute_max_vol =
          !newState.steps.tuners_absolute_selection.absolute_max_vol;
        newState.steps.tuners_absolute_selection.absolute_min_return = false;
        newState.steps.tuners_absolute_selection.absolute_max_beta = false;

        newState.steps.tuners_absolute_selection.selected_type =
          payload.value === false ? "" : payload.name;
      } else if (payload.name === "min_return") {
        newState.steps.tuners_absolute_selection.absolute_max_vol = false;
        newState.steps.tuners_absolute_selection.absolute_min_return =
          !newState.steps.tuners_absolute_selection.absolute_min_return;
        newState.steps.tuners_absolute_selection.absolute_max_beta = false;

        newState.steps.tuners_absolute_selection.selected_type =
          payload.value === false ? "" : payload.name;
      } else if (payload.name === "max_beta") {
        newState.steps.tuners_absolute_selection.absolute_max_vol = false;
        newState.steps.tuners_absolute_selection.absolute_min_return = false;
        newState.steps.tuners_absolute_selection.absolute_max_beta =
          !newState.steps.tuners_absolute_selection.absolute_max_beta;

        newState.steps.tuners_absolute_selection.selected_type =
          payload.value === false ? "" : payload.name;
      } else if (payload.name === "") {
        newState.steps.tuners_absolute_selection.absolute_max_vol = false;
        newState.steps.tuners_absolute_selection.absolute_min_return = false;
        newState.steps.tuners_absolute_selection.absolute_max_beta = false;
        newState.steps.tuners_absolute_selection.selected_type = "";
      }

      break;

    case "RESET_CREATE_STEP_ABSOLUTE_SWITCH_HANDLER":
      newState.steps.tuners_absolute_selection.selected_type = "";
      newState.steps.tuners_absolute_selection.absolute_max_vol = false;
      newState.steps.tuners_absolute_selection.absolute_min_return = false;
      newState.steps.tuners_absolute_selection.absolute_max_beta = false;
      break;

    case "SET_CREATE_PORTFOLIO_TYPE":
      newState.create_portfolio_type = action.payload;
      break;
    default:
      return state;
  }

  return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/create.reducer.js